module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAARVBMVEUAAADMzMzKysrGxsbGxsbGxsbDw8PGxsbDw8PExMTExMTDw8PDw8PDw8PDw8PExMTDw8PCwsLCwsLCwsLCwsLCwsLCwsINc+qWAAAAFnRSTlMAFBgbLTY3R0hJSmFih4mSvtrb3/f4TSAVawAAALhJREFUOMvl1EESgyAMBVAUFU1tlYq5/1ELlnYMBOJedvx5bsiPSt35dA2fNx29z+iAc+DwQYIX4s5I2BGfJGnfXk6pm7yzLc00Iw+n069zybtcllyU4+82Fh2VNXeWdRelUcoIzkuL6IxxkovygvvKKy70w59ZdqEHfENyZ60sD6e1KCG+nyTh/851Cad51CSQuZUlJPMtSch6wEtg+sLJnt+jIHsSLYU98nIhybCt/B6t23DnP+0HqkkSTYKp3OEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-close.png
// module id = 5Usy
// module chunks = 1